/**
 * Helpers de permissions partagés — miroir de la logique de App.js
 * (canView / canViewSubRubrique) pour être réutilisés dans Raccourcis, etc.
 */

const ROLE_DEFAULTS_TAB = {
  'Secrétaire':  ['actualites','actualites_news','quizz','taches_jour','planning','conges','personnel','annuaire','messages','coffre_fort','tutos','infos_patient','stocks','recuperation_especes'],
  'Assistant':   ['actualites','actualites_news','quizz','taches_jour','planning','conges','personnel','annuaire','messages','coffre_fort','tutos','infos_patient','stocks','recuperation_especes'],
  'Assistant(e)':['actualites','actualites_news','quizz','taches_jour','planning','conges','personnel','annuaire','messages','coffre_fort','tutos','infos_patient','stocks','recuperation_especes'],
  'Médecin':     ['actualites','actualites_news','quizz','planning','conges','demandes_creneaux','messages','coffre_fort','tutos','infos_patient','ressources','bloc_operatoire','registre_factures','coffre_fort_factures','recuperation_especes'],
  'Manager':     ['actualites','actualites_news','plan_cabinet','quizz','taches_jour','planning','conges','personnel','annuaire','demandes_creneaux','messages','coffre_fort','tutos','infos_patient','stocks','salles','admin','ressources','bloc_operatoire','materiel_bloc','recuperation_especes'],
  'Orthoptiste': ['actualites','actualites_news','quizz','taches_jour','planning','conges','messages','coffre_fort','tutos','infos_patient','recuperation_especes'],
};

const ROLE_DEFAULTS_SUB = {
  'Secrétaire':  ['actualites_news','dossiers_a_traiter','quizz','taches_jour','stocks','annuaire','champ_visuel'],
  'Assistant':   ['actualites_news','dossiers_a_traiter','quizz','taches_jour','stocks','annuaire','champ_visuel'],
  'Assistant(e)':['actualites_news','dossiers_a_traiter','quizz','taches_jour','stocks','annuaire','champ_visuel'],
  'Médecin':     ['actualites_news','dossiers_a_traiter','quizz','tutos','infos_patient','bloc_operatoire','champ_visuel'],
  'Manager':     ['actualites_news','dossiers_a_traiter','plan_cabinet','quizz','taches_jour','stocks','tutos','infos_patient','notes','annuaire','bloc_operatoire','materiel_bloc'],
  'Orthoptiste': ['actualites_news','quizz','taches_jour','tutos','infos_patient'],
};

const isDirector = (user) => user?.role === 'Directeur' || !!user?.autorisations?.admin?.droits_directeur;

export const canViewRubrique = (user, rubrique) => {
  if (!user || !rubrique) return false;
  if (isDirector(user)) return true;
  const auth = user.autorisations?.[rubrique];
  if (auth && ('voir' in auth || 'droits_directeur' in auth)) {
    return !!(auth.voir || auth.droits_directeur);
  }
  return (ROLE_DEFAULTS_TAB[user.role] || []).includes(rubrique);
};

export const canViewSubRubrique = (user, rubrique) => {
  if (!user || !rubrique) return false;
  if (isDirector(user)) return true;
  const auth = user.autorisations?.[rubrique];
  if (auth && ('voir' in auth || 'droits_directeur' in auth)) {
    return !!(auth.voir || auth.droits_directeur);
  }
  return (ROLE_DEFAULTS_SUB[user.role] || []).includes(rubrique);
};

/**
 * Vérifie si un employé peut utiliser (voir/ajouter) un raccourci de commande.
 * `command.rubrique` (string) OU `command.anyOf` (string[]) OU `command.always: true`.
 */
export const canUseCommand = (user, command) => {
  if (!command) return false;
  if (command.directorOnly) return isDirector(user);
  if (command.always) return true;
  if (isDirector(user)) return true;
  if (command.anyOf && Array.isArray(command.anyOf)) {
    return command.anyOf.some(r => canViewRubrique(user, r) || canViewSubRubrique(user, r));
  }
  if (command.rubrique) {
    return canViewRubrique(user, command.rubrique) || canViewSubRubrique(user, command.rubrique);
  }
  // Pas de rubrique déclarée → considérer accessible (ex: préférences globales)
  return true;
};
